import { createFileRoute } from "@tanstack/react-router";
import { BrancherIndexPage, brancherHead } from "@/pages/BrancherIndexPage";

export const Route = createFileRoute("/de/branchen/")({
  head: () => brancherHead("de"),
  component: () => <BrancherIndexPage locale="de" />,
});
